import { render, staticRenderFns } from "./LargeMedia.vue?vue&type=template&id=18fbac99&"
import script from "./LargeMedia.vue?vue&type=script&lang=js&"
export * from "./LargeMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports